<template>
  <div class="w-full h-full absolute z-99" v-loading="loadingEngine">
    <img id="playerEngineId" class="w-full h-full" v-if="cloudRenderLoadMode === 'img'" />
    <video
      id="playerEngineId"
      autoplay
      playsinline
      muted
      class="w-full h-full object-fill"
      v-if="cloudRenderLoadMode !== 'img' && !showScreenShot"
    ></video>
    <!-- 断开会话显示最后一帧截图 -->
    <img
      class="h-full w-full"
      v-if="cloudRenderLoadMode !== 'img' && showScreenShot"
      :src="screenShotSrc"
    />
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>

<script>
import { instance as CloudRender } from 'wiz-cloud-render-vulkan'
import DiyCommon from '@/services/pageService/diyCommon'

const PlayerProgress = () => {
  return import('./PlayerProgress')
}
export default {
  components: {
    PlayerProgress,
  },
  props: {
    modelFileInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadType: '',
      loadPercentage: 0,
      showLoadProgress: false,
      loadingEngine: false,
      screenShotSrc: '',
      showScreenShot: false,
      player: null,
      currentModelFile: {},
      textureFileLoaded: false,
    }
  },
  watch: {
    modelFileInfo: {
      async handler(val, oldVal) {
        this.currentModelFile = _.cloneDeep(val)
        if (val.Id !== oldVal.Id && this.player) {
          await CloudRender.Node.destroyAllNode()
          this.loadSceneModel()
        } else if (oldVal.Id) {
          this.$emit('loadModelEnd')
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.loadingEngine = true
    this.showLoadProgress = false
    this.init()
    this.$nextTick(async () => {
      if (this.player) {
        CloudRender.Engine.destroyEngine()
      }
    })
    window.addEventListener('beforeunload', async (e) => {
      if (this.player) {
        CloudRender.Engine.destroyEngine()
      }
    })
  },
  computed: {
    // 模型相关设置
    modelSettings() {
      return _.get(Wiz, 'globalSettings.globalConfig')?.modelSetting || {}
    },
    cloudRenderLoadMode() {
      // 云渲染加载模式
      return this.modelSettings?.cloudRenderLoadMode || 'video'
    },
    // 云渲染协议
    cloudProtocol() {
      return this.modelSettings?.cloudProtocol || 'ws'
    },
    // 云渲染服务路径
    cloudServerPath() {
      return this.modelSettings?.cloudServerPath || 'renderapi03-vk.wiz.top:8082'
    },
    // 地图路径
    globalMapPath() {
      return this.modelSettings?.globalMapPath || 'data://gis/gisdata_wiz_top_9100.gis.xml'
    },
  },
  methods: {
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (this.performance && typeof this.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    // 加载引擎
    async runPlayer() {
      this.loadingEngine = true
      const engineId = this.generateUUID()
      const param = {
        signalServer: `${this.cloudProtocol}://${this.cloudServerPath}`,
        options: {
          videoDom: document.getElementById('playerEngineId'),
          limtMoveCPS: 10, // 限制每秒鼠标移动的消息个数
          userTimeout: 1000 * 60 * 60, // 用户操作超时设置，毫秒
          engineId: engineId || this.modelEngineId, // 引擎会话id，如果已存在则连接，没有则创建，会话在断开连接后超时自动关闭
          exitTimeout: 1000 * 60, // 用户超时后多久断开会话
          maxTimeout: 1000, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
          openDebug: true,
        },
      }
      const { data } = await CloudRender.Engine.loadEngine(param)
      console.log('创建的引擎', data)
      this.player = data.getDataInfo()
      CloudRender.Dispatch.on('Engine', async (e) => {
        if (e.type === 'UserTimeOut') {
          // 用户操作超时
          console.error('用户操作超时')
        }
        if (e.type === 'TimeOutExit') {
          // 断开会话
          console.error('超时断开')
        }
      })
      window.player = this.player
      window.CloudRender = CloudRender
      this.loadingEngine = false
      if (this.currentModelFile.Id) {
        this.initPlayer()
      }
    },
    async init() {
      this.runPlayer()
    },
    // 初始化player
    async initPlayer() {
      this.$emit('sendPlayer', this.player, CloudRender)
      this.loadSceneModel()
    },
    // 加载、下载进度
    loadModelConnect: _.throttle(async function loadMsg(res) {
      if (res.status && res.data && res.data.type === 'nodeStatus') {
        switch (res.data.currentState) {
          case 1:
            this.showLoadProgress = true
            this.loadType = '模型加载中...'
            this.loadPercentage = _.round(res.data.process, 2)
            break
          case 3:
            this.showLoadProgress = true
            this.loadType = '模型下载中...'
            this.loadPercentage = _.round(res.data.process, 2)
            break
          case 4:
            this.showLoadProgress = false
            this.loadType = ''
            this.loadPercentage = 0
            CloudRender.Dispatch.off('loadNode', this.loadModelConnect)
            this.loadModelEnd()
            this.$emit('loadModelEnd')
            break
          case 5:
            this.showLoadProgress = false
            this.loadType = ''
            this.loadPercentage = 0
            break
          default:
            break
        }
      }
      if (!res.status) {
        this.$message.warning(res.message)
        this.showLoadProgress = false
        this.loadType = ''
        this.loadPercentage = 0
      }
    }, 500),
    // 加载模型
    async loadSceneModel() {
      CloudRender.Dispatch.on('loadNode', this.loadModelConnect)
      const fileType = this.currentModelFile.ModelFile.split('.')
        .at(-1)
        .toLocaleLowerCase()
      const query = {
        targetUrl: `data://../apps/${this.modelSettings.folderName || 'XDJ'}/models/${
          this.currentModelFile.Id
        }/${this.currentModelFile.Id}.${fileType}`,
        fileUrl: `${window.FileServer || 'http://192.168.67.108:9010/public'}${
          this.currentModelFile.ModelFile
        }`,
        tempPath: `data://../temps/models/${this.currentModelFile.Id}/${this.currentModelFile.Id}.${fileType}`,
        options: {
          nodeId: this.currentModelFile.Id,
          httpOptions: {
            methods: 'GET',
          },
        },
      }
      if (this.currentModelFile.ModelPic) {
        const guid = this.generateUUID()
        query.options.nodeDecals = {
          targetUrl: `data://../apps/${this.modelSettings.folderName || 'XDJ'}/models/${
            this.currentModelFile.Id
          }/${guid}.zip`,
          fileUrl: `${window.FileServer || 'http://192.168.67.108:9010/public'}${
            this.currentModelFile.ModelPic
          }`,
        }
      }
      console.log('加载模型参数', query)
      const res = await CloudRender.Node.addNode(query)
      console.log('模型加载结果', res)
    },
    // 场景加载完成
    async loadModelEnd() {
      const cameraParams = this.modelSettings.defaultCameraParam
      if (cameraParams && cameraParams.eye) {
        CloudRender.Camera.moveCamera('CameraParam', cameraParams)
      } else {
        const nodeRes = CloudRender.Node.getInfo(this.currentModelFile.Id)
        console.log('加载完成', nodeRes, new Date())
        CloudRender.Camera.moveCamera(
          'Node',
          {
            id: nodeRes.data.id,
          },
          2
        )
      }
    },
  },
  async beforeDestroy() {
    if (this.player) {
      CloudRender.Engine.destroyEngine()
    }
  },
}
</script>

<style lang="scss" scoped></style>
